import './Fab.69536f5a76d786d4c111337b1808e504.css';
export default {"fab":"_fab_14g9k_1","open":"_open_14g9k_1","handler":"_handler_14g9k_1","mainButton":"_mainButton_14g9k_1","fadeIn":"_fadeIn_14g9k_1","rotate":"_rotate_14g9k_1"};